






































import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator";
import VueI18n from "vue-i18n";
import {
  RPA_TEMPLATE,
  IRule,
  INIT_DATA_TEMPLATE,
  RPA_RULE_ACTION,
  PHASE,
  IDataTemplate,
  RPA_RULE_SINCE,
} from "./index";
import RuleTemplate from "./RuleTemplate.vue";
import SelectRuleTemplateDialog from "./SelectRuleTemplateDialog.vue";

enum ACTION_TEMPLATE {
  ADD_TEMPLATE = "ADD_TEMPLATE",
  CHANGE_TEMPLATE = "CHANGE_TEMPLATE",
}

@Component({
  components: {
    RuleTemplate,
    SelectRuleTemplateDialog,
  },
})
export default class RulePharse extends Vue {
  @Prop() value: IRule[];
  @Prop() phase: PHASE;
  @Prop({ default: [] }) variableOptions;
  @Prop({ default: [] }) packageOptions;
  @Prop({ default: false }) isViewMode: boolean;
  isShowSelectRuleTemplateDialog = false;
  selectedAction: ACTION_TEMPLATE = null;
  ruleKeySelected: number = null;

  mounted() {}

  get ruleList() {
    return this.value;
  }

  set ruleList(val) {
    this.$emit("input", val);
  }

  get ruleCounter(): number {
    return this.ruleList.length;
  }

  showSelectRuleTemplateDialog() {
    this.isShowSelectRuleTemplateDialog = true;
  }

  hideSelectRuleTemplateDialog() {
    this.isShowSelectRuleTemplateDialog = false;
  }

  onSelectTemplate(selectedTemplate: RPA_TEMPLATE) {
    this.hideSelectRuleTemplateDialog();
    // if (this.selectedAction === ACTION_TEMPLATE.ADD_TEMPLATE)
    //   this.doAddRule(selectedTemplate);
    // if (this.selectedAction === ACTION_TEMPLATE.CHANGE_TEMPLATE)
      this.doChangeRule(this.ruleKeySelected, selectedTemplate);
  }

  onAddRule() {
    this.selectedAction = ACTION_TEMPLATE.ADD_TEMPLATE;
    this.doAddRule(null);
    // this.showSelectRuleTemplateDialog();
  }

  onChangeTemplate(ruleKey: number) {
    this.selectedAction = ACTION_TEMPLATE.CHANGE_TEMPLATE;
    this.ruleKeySelected = ruleKey;
    this.showSelectRuleTemplateDialog();
  }

  onRemoveRule(ruleKey: number) {
    this.ruleList = this.ruleList.filter((rule) => rule.ruleKey !== ruleKey);
  }

  get isOtherPhase() {
    return this.phase === PHASE.PHASE_OTHER;
  }

  createdDataTemplate(
    selectedTemplate: RPA_TEMPLATE,
    optionDataTemplate?: IDataTemplate
  ): IDataTemplate {
    return {
      ...INIT_DATA_TEMPLATE,
      template: selectedTemplate,
      action: this.isOtherPhase
        ? RPA_RULE_ACTION.ACTION_TECHNICAL_CHECKING
        : null,
      ...optionDataTemplate,
    };
  }

  doAddRule(selectedTemplate: RPA_TEMPLATE) {
    switch (selectedTemplate) {
      case RPA_TEMPLATE.TEMPLATE_1: {
        this.ruleList.push({
          ruleKey: this.ruleCounter,
          rpaTemplate: selectedTemplate,
          dataTemplate: this.createdDataTemplate(selectedTemplate),
          phase: this.phase,
        });
        break;
      }
      case RPA_TEMPLATE.TEMPLATE_2: {
        this.ruleList.push({
          ruleKey: this.ruleCounter,
          rpaTemplate: selectedTemplate,
          dataTemplate: this.createdDataTemplate(selectedTemplate, {
            since: RPA_RULE_SINCE.RPA_RULE_SINCE_BEGINNING,
          }),
          phase: this.phase,
        });
        break;
      }
      case RPA_TEMPLATE.TEMPLATE_3: {
        this.ruleList.push({
          ruleKey: this.ruleCounter,
          rpaTemplate: selectedTemplate,
          dataTemplate: this.createdDataTemplate(selectedTemplate, {
            since: RPA_RULE_SINCE.RPA_RULE_SINCE_BEGINNING,
          }),
          phase: this.phase,
        });
        break;
      }
      default: {
        this.ruleList.push({
          ruleKey: this.ruleCounter,
          rpaTemplate: selectedTemplate,
          dataTemplate: this.createdDataTemplate(RPA_TEMPLATE.TEMPLATE_1),
          phase: this.phase,
        });
        break;
      }
    }
  }

  doChangeRule(ruleKeySelected: number, selectedTemplate: RPA_TEMPLATE) {
    const selectedRule: IRule = this.ruleList.find(
      (ruleTemplate) => ruleTemplate.ruleKey === ruleKeySelected
    );
    selectedRule.rpaTemplate = selectedTemplate;
    selectedRule.dataTemplate.template = selectedTemplate;
    selectedRule.dataTemplate.variableId = null;
    selectedRule.dataTemplate.otherVariableId = null;
    if (selectedTemplate === RPA_TEMPLATE.TEMPLATE_2 || selectedTemplate === RPA_TEMPLATE.TEMPLATE_3) {
      selectedRule.dataTemplate.since = RPA_RULE_SINCE.RPA_RULE_SINCE_BEGINNING;
    }
  }
}
